const ctaBgImage = "https://readdy.ai/api/search-image?query=Warm%20abstract%20technology%20background%20with%20soft%20geometric%20shapes%2C%20flowing%20organic%20lines%20in%20olive%20green%20and%20cream%20tones%2C%20minimalist%20modern%20design%2C%20wide%20panoramic%20composition%2C%20clean%20professional%20aesthetic%2C%20subtle%20gradient%20with%20warm%20atmosphere%2C%20no%20text%20no%20people%2C%20abstract%20digital%20art%20suitable%20for%20tech%20company%20background";

export default function CTASection() {
  return (
    <section id="cta" className="relative w-full py-24 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${ctaBgImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          <div className="max-w-xl">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              准备好开始
              <br />
              你的数字化之旅了吗？
            </h2>
            <p className="text-white/70 text-sm md:text-base mt-4 leading-relaxed max-w-md">
              无论你是需要一个全新的网站，还是想要升级现有的技术架构，我们都在这里等你。
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              预约免费咨询
              <span className="w-5 h-5 flex items-center justify-center bg-primary-500 text-background-50 rounded-full">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
            <a
              href="#services"
              className="inline-flex items-center gap-2 text-white/80 text-sm md:text-base font-medium hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}